/**
 * assets/backcountry-image-loader.js
 * Handles image loaders to ensure smooth image fade-ins.
 * Triggers the 'is-loaded' class when images complete loading.
 */
const BackcountryImageLoader = {
  settings: {
    selectors: {
      loadInImage: '.backcountry-image-load',
    }
  },

  /**
   * Initializes image loaders.
   * * @returns {void}
   */
  initImageLoaders() {
    const { selectors } = this.settings;

    document.querySelectorAll(selectors.loadInImage).forEach(img => {
      const onImageLoad = () => {
        img.classList.add('is-loaded');
        // Image loading might shift layout, so recalculate parallax
      };

      if (img.complete) {
        onImageLoad();
      } else {
        img.addEventListener('load', onImageLoad);
      }
    });
  },
};

// Init on load
document.addEventListener('DOMContentLoaded', () => BackcountryImageLoader.initImageLoaders());

// Init on 'Theme Editor' change (a Shopify specific event)
document.addEventListener('shopify:section:load', () => BackcountryImageLoader.initImageLoaders());
